<template>
  <div class="sidebar">
    <div class="sidebar__graph" v-if="soliBerechnet">
      <div class="bar-chart">
        <div class="box" v-if="soliErsparnis > 0 || estErsparnis > 0">
          <div class="bar bar-1"
               v-if="soliErsparnis > 0"
               :style="{ height: getHeight(soliErsparnis) + '%' }"> Soli Ersparnis </div>
          <div class="bar bar-2"
               v-if="estErsparnis > 0"
               :style="{ height: getHeight(estErsparnis) + '%' }"> Steuer Ersparnis </div>
        </div>
      </div>
    </div>
    <slot name="zwischenergebnis"></slot>
    <slot name="ergebnis"></slot>
    <div class="sidebar__legende">
      <span v-if="soliBerechnet" @click="dialogIsOpen = true">
        <span class="hint">*</span>Rechtliche Hinweise</span>
      <custom-dialog @close-dialog="dialogIsOpen = false" v-if="dialogIsOpen">
        <template v-slot:dialog-header>
          <h3 class="m-0">Rechtliche Hinweise</h3>
        </template>
        <template v-slot:dialog-content>
          Die Berechnung ist eine unverbindliche Modell Rechnung auf Basis der Einkommenssteuer nach aktueller Steuer
          – und Sozialversicherungsgesetzgebung. Abhängig von der hier nicht geprüften individuellen steuerlichen
          Situation kann das Ergebnis variieren. Das Ergebnis beinhaltet die Ersparnis bezüglich Solidaritätszuschlag
          für 2021 gegenüber 2020. Folgende Annahmen wurden getroffen: Arbeitnehmer, RV Satz 18,6%, RV West, PV Satz
          3,05% bzw. 3,3% für Kinderlose. Bei gemeinsamer Veranlagung: Ehepartner zahlen selben KV Satz.
          <br><br>
          Da die Berechnung der zu vergleichenden Solidaritätszuschläge in der Realität erheblich komplexer und dafür
          die Erhebung einer deutlich größeren Datenmenge erforderlich ist, wird dem Nutzer die Eingabe wesentlich erleichtert,
          um ihm eine schnelle Informationsgewinnung in Form einer Ersteinschätzung zu ermöglichen.
          Diese unverbindliche Ersteinschätzung der zu erwartenden Ersparnis ersetzt eine persönliche Beratung durch
          einen Steuerberater nicht.
          <br><br>
          Die zur Berechnung erhobenen Daten werden ausschließlich hierfür verwendet und nicht gespeichert.
        </template>
      </custom-dialog>
    </div>
  </div>
</template>

<script>
import CustomDialog from "@/components/form/Dialog/CustomDialog";
export default {
  name: 'sidebar',
  components: {
    CustomDialog
  },
  props: {
    soliBerechnet: {
      type: Boolean,
      required: true
    },
    soliErsparnis: {
      type: Number,
      required: true
    },
    estErsparnis: {
      type: Number,
      required: true
    }
  },
  methods: {
    getHeight (value) {
      const gesamt = this.estErsparnis + this.soliErsparnis

      return (value * 100) / gesamt
    }
  },
  data() {
    return {
      dialogIsOpen: false,
    }
  }
}
</script>

<style lang="scss">
.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  height: 100%;
  width: 100%;
  //position: relative;

  @include lg {
    justify-content: flex-start;
    //justify-content: center;
  }

  @include rwd(992) {
    justify-content: flex-start;
  }

  &__graph {
    display: none;
    height: 0;

    @include lg {
      margin-top: -5rem;
      height: 50%;

    }

    @include rwd(992) {
      margin-top: 0;
      height: 40%;

      .bar-chart {
        width: 50%;
      }
    }

    // 992px window width and more
    @include lg {
      width: 100%;
      margin-bottom: 3rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 0 2rem;
      transition: all ease-in-out 1s;
      .bar-chart {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 57%;
      }

      .box {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
        display: flex;
        flex-direction: column;
        //max-height: 400px;
        height: 100%;

        .bar {
          display: flex;
          justify-content: center;
          align-items: center;
          color: rgba(#333, .5);
          font-size: $font-size-xs;
          text-transform: uppercase;

          &-1 {
            background: $primary;
            color: $white;
            height: 50%;
          }

          &-2 {
            background: $white;
            height: 50%;
          }
        }
      }
    }
  }

  &__headline {
    display: none;
    margin-bottom: 0;
    font-size: 0;
    height: 0;
    padding: 0 2rem;

    @include lg {
      padding: 0 1.75rem;
    }

    @include rwd(992) {
      padding: 0 2rem;
    }

    @include lg {
      margin-bottom: 1.5rem;
      font-size: $font-size-xs;
      color: rgba(#333, 0.75);
      font-weight: 500;
      display: inline-block;
    }

    @include rwd(992) {
      font-size: 1rem
    }
  }

  &__info {
    width: 100%;
    padding: 0 1rem;

    @include lg {
      padding: 0 1.75rem;
    }

    @include rwd(992) {
      padding: 0 2rem;
    }

    & li {
      list-style: none;
      font-weight: 300;
      color: rgba(#333, .75);
      line-height: 1.25rem;
      opacity: .75;
      font-size: $font-size-sm;

      // 992px window width and more
      @include lg {
        line-height: 2rem;
        font-size: $font-size-xs;
      }

      @include rwd(992) {
        line-height: 2rem;
        font-size: 1rem;
      }

      & > span.number {
        float: right;
        font-weight: 500;
      }

      &:last-child {
        margin-top: .6rem;
        font-weight: 700;

        @include sm {
          margin-top: 1rem;
        }
        @include lg {
          margin-top: 3rem;
        }

        &.soli {
          opacity: 1;

          & > span.number {
            color: $primary;
          }

          // 992px window width and more
          @include lg {
            font-size: $font-size-md;
            & > span.number {
              color: $primary;
              font-weight: 700;

              & > span.info {
                font-size: $font-size-xs;
                font-weight: 400;

                &-2 {
                  font-size: $font-size-base;
                }
              }
            }
          }
        }
      }
    }
  }

  &__legende {
    position: absolute;
    bottom: $font-size-xs;
    left: 0;
    font-weight: 500;
    color: rgba(#333, .75);
    font-size: $font-size-xs;
    padding: 0 1.5rem;
    margin-top: .5rem;

    span {
      cursor: pointer;
      text-decoration: underline;
    }
    span:not(:last-child){margin-right: 1rem;}

    @include rwd(992) {
      bottom: .5rem;
      font-size: 1rem;
    }
  }
}
</style>
